import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import _ from 'lodash';
import { stringify } from 'query-string';
import { Link } from 'react-router-dom';
import { pure } from 'recompose';
import { propArrayShape } from '../../../../helpers/custom-prop-types';
const SearchCardThemeItems = pure((props) => {
    const { themeList } = props;
    if (themeList.length === 0) {
        return null;
    }
    const rankList = _.uniq(themeList.map(({ count }) => count))
        .sort((a, b) => a - b)
        .reverse();
    const newThemeList = themeList.map((obj) => {
        const rank = rankList.findIndex((v) => v === obj.count) + 1;
        let className = '';
        if (rank <= 3) {
            className = 'primary';
        }
        else if (rank <= 6 && obj.count > 0) {
            className = 'secondary';
        }
        return Object.assign(Object.assign({}, obj), { className });
    });
    return (_jsx("ul", Object.assign({ className: 'theme_list' }, { children: newThemeList.map((theme) => (_jsx("li", Object.assign({ className: 'theme_list_col' }, { children: _jsxs(Link, Object.assign({ className: `theme_list_col_inner ${theme.className}`, to: `/consultant/search?${stringify({ keyword: theme.name })}` }, { children: [_jsx("p", Object.assign({ className: 'label' }, { children: theme.name })), _jsxs("p", { children: [_jsx("strong", Object.assign({ className: 'strong' }, { children: theme.count })), _jsx("span", Object.assign({ className: 'prefix' }, { children: "\u4EBA" }))] })] })) }), theme.id))) })));
});
SearchCardThemeItems.propTypes = {
    themeList: propArrayShape().isRequired,
};
export default SearchCardThemeItems;
